function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "#FF9D25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint0_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint1_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint2_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint3_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint4_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint5_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint6_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint7_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2623 22.4476L24.1076 13.0575C24.0086 12.1665 23.5197 10.9692 21.849 10.9692C19.8998 11.062 19.8225 13.0575 19.8225 13.0575L16.8523 7.75151C16.1098 6.62222 14.892 6.54363 14.1297 7.00895C13.3674 7.47428 13.2015 8.41669 13.2015 8.41669L12.5827 7.61227C12.1174 6.84993 10.7249 6.76115 10.0148 7.1946C8.83616 7.91403 8.66488 9.4036 9.42696 10.2266C9.37697 10.1726 8.79455 9.97095 7.81812 10.567C7.05578 11.0323 6.8203 12.4234 7.24572 13.2123C7.67115 14.0011 7.73302 14.1249 7.73302 14.1249C7.73302 14.1249 7.07557 13.8155 6.03911 14.5116C5.29768 15.0096 5.03234 16.4875 5.49767 17.2498L7.99384 21.4585L11.4293 27.0721C13.449 29.9348 17.7553 30.9233 20.8843 29.0225C23.0178 27.7264 24.4655 24.9876 24.2623 22.4476Z",
  fill: "url(#paint8_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.6902 14.1086C7.57811 14.0842 7.47176 14.0675 7.37596 14.0572C7.5281 14.0625 7.63512 14.0903 7.6902 14.1086ZM7.72923 14.1174C7.76063 14.1247 7.79242 14.1326 7.8245 14.1412C8.15011 14.2278 8.45017 14.366 8.6522 14.5456C8.75352 14.6357 8.90685 14.8211 9.10438 15.1011C9.29552 15.3721 9.50735 15.7014 9.72646 16.0544C9.90354 16.3397 10.0883 16.6455 10.2684 16.9437C10.5233 17.3656 10.769 17.7722 10.9708 18.0842C11.1209 18.316 11.4304 18.3823 11.6623 18.2323C11.8941 18.0823 11.9604 17.7728 11.8104 17.5409C11.613 17.2358 11.3849 16.858 11.14 16.4523L11.14 16.4523L11.14 16.4523C10.9594 16.1531 10.7696 15.8387 10.5761 15.527C10.3534 15.1683 10.1295 14.8196 9.92153 14.5247C9.71992 14.2389 9.51068 13.9707 9.31656 13.7982C8.95609 13.4778 8.49312 13.2843 8.08176 13.1748C7.76108 13.0894 7.43772 13.0461 7.16837 13.0442C7.19115 13.1026 7.21693 13.1588 7.24573 13.2122C7.61589 13.8987 7.71082 14.0815 7.72923 14.1174Z",
  fill: "url(#paint9_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.37754 10.1988C9.29741 10.177 9.222 10.1624 9.15165 10.1533C9.25541 10.1608 9.33135 10.1804 9.37754 10.1988ZM9.40998 10.208C9.6899 10.2898 10.0252 10.4605 10.4022 10.7956C10.4308 10.821 10.4977 10.8967 10.6047 11.0472C10.7055 11.1889 10.8242 11.3715 10.9571 11.5867C11.2226 12.0169 11.5319 12.5573 11.8479 13.1211C12.0139 13.4173 12.1827 13.7218 12.3477 14.0194L12.3478 14.0194L12.3478 14.0195C12.8012 14.8372 13.226 15.6035 13.4865 16.006C13.6365 16.2379 13.946 16.3042 14.1779 16.1542C14.4097 16.0042 14.476 15.6946 14.326 15.4628C14.0855 15.0911 13.6894 14.3767 13.2447 13.5746L13.2446 13.5745C13.0749 13.2685 12.8982 12.9496 12.7202 12.6322C12.4031 12.0664 12.0853 11.5107 11.8081 11.0615C11.6696 10.8371 11.5381 10.6342 11.4196 10.4676C11.3072 10.3097 11.1857 10.154 11.0666 10.0482C10.2708 9.34083 9.53737 9.14482 8.96988 9.14026C8.99729 9.53586 9.14509 9.91302 9.40998 10.208Z",
  fill: "url(#paint10_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2016 8.41619L13.2933 8.56373C13.6278 9.10191 14.081 9.83059 14.5558 10.5925C15.5036 12.1138 16.5418 13.7748 16.8885 14.3107C17.0385 14.5425 17.348 14.6088 17.5799 14.4588C17.8117 14.3088 17.8781 13.9992 17.728 13.7674C17.3872 13.2407 16.3551 11.5893 15.4045 10.0637C14.93 9.30216 14.477 8.5738 14.1426 8.03581L13.7421 7.3913L13.7204 7.35645C13.3107 7.82484 13.2047 8.39878 13.2016 8.41619Z",
  fill: "url(#paint11_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.1527 13.6707L23.2951 22.3123C23.4821 24.6499 22.1498 27.1704 20.1863 28.3632C19.8159 28.5883 19.4275 28.7693 19.0279 28.9083C16.874 28.9303 14.7251 27.9342 13.4924 26.187L11.0532 22.8635L9.46546 20.1078C9.03292 19.3991 9.27956 18.0254 9.96875 17.5625C10.9322 16.9154 11.5433 17.203 11.5433 17.203C11.5433 17.203 10.7532 15.9315 10.3578 15.1982C9.96233 14.4649 10.1742 13.3466 10.8828 12.9141C11.7905 12.3601 12.5317 13.0123 12.5781 13.0625C11.9844 12.2578 11.9356 10.45 13.0312 9.78127C13.6913 9.37836 14.8863 9.28408 15.3188 9.99271L15.894 10.7405C15.894 10.7405 16.0481 9.86444 16.7568 9.4319C16.7765 9.41986 16.7965 9.40822 16.8169 9.39697L19.2092 13.6707C19.2092 13.6707 19.2581 12.4074 20.2982 11.9276L22.0485 15.0544C22.0485 15.0544 22.0962 13.8237 23.093 13.3205C23.1209 13.4402 23.1402 13.5581 23.1527 13.6707Z",
  fill: "#F06B0C"
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.9531 22.3716V12.8872C29.8531 11.9872 29.2031 10.7779 27.5156 10.7779C25.5469 10.8716 25.4688 12.8872 25.4688 12.8872L22.4688 7.5279C21.7188 6.38726 20.4888 6.30788 19.7188 6.77788C18.9488 7.24788 18.7813 8.19976 18.7813 8.19976L18.1563 7.38726C17.6863 6.61726 16.2798 6.52758 15.5625 6.96538C14.372 7.69204 14.199 9.19658 14.9688 10.0279C14.9183 9.97335 14.0569 9.86375 13.3438 10.3716C12.5486 10.938 12.3359 12.2467 12.7656 13.0435C13.1953 13.8403 13.2578 13.9653 13.2578 13.9653C13.2578 13.9653 12.5938 13.6528 11.5469 14.356C10.798 14.8589 10.53 16.3516 11 17.1216L13.5212 21.3726L16.9912 27.0426C19.0313 29.9341 23.3808 30.9325 26.5412 29.0126C28.6962 27.7036 30.1584 24.9372 29.9531 22.3716Z",
  fill: "#FFC03C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9531 22.3716V12.8872C29.8531 11.9872 29.2031 10.7779 27.5156 10.7779C25.5469 10.8716 25.4688 12.8872 25.4688 12.8872L22.4688 7.5279C21.7188 6.38726 20.4888 6.30788 19.7188 6.77788C18.9488 7.24788 18.7813 8.19976 18.7813 8.19976L18.1563 7.38726C17.6863 6.61726 16.2798 6.52758 15.5625 6.96538C14.372 7.69204 14.199 9.19658 14.9688 10.0279C14.9183 9.97335 14.0569 9.86375 13.3438 10.3716C12.5486 10.938 12.3359 12.2467 12.7656 13.0435C13.1953 13.8403 13.2578 13.9653 13.2578 13.9653C13.2578 13.9653 12.5938 13.6528 11.5469 14.356C10.798 14.8589 10.53 16.3516 11 17.1216L13.5212 21.3726L16.9912 27.0426C19.0313 29.9341 23.3808 30.9325 26.5412 29.0126C28.6962 27.7036 30.1584 24.9372 29.9531 22.3716Z",
  fill: "url(#paint12_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9531 22.3716V12.8872C29.8531 11.9872 29.2031 10.7779 27.5156 10.7779C25.5469 10.8716 25.4688 12.8872 25.4688 12.8872L22.4688 7.5279C21.7188 6.38726 20.4888 6.30788 19.7188 6.77788C18.9488 7.24788 18.7813 8.19976 18.7813 8.19976L18.1563 7.38726C17.6863 6.61726 16.2798 6.52758 15.5625 6.96538C14.372 7.69204 14.199 9.19658 14.9688 10.0279C14.9183 9.97335 14.0569 9.86375 13.3438 10.3716C12.5486 10.938 12.3359 12.2467 12.7656 13.0435C13.1953 13.8403 13.2578 13.9653 13.2578 13.9653C13.2578 13.9653 12.5938 13.6528 11.5469 14.356C10.798 14.8589 10.53 16.3516 11 17.1216L13.5212 21.3726L16.9912 27.0426C19.0313 29.9341 23.3808 30.9325 26.5412 29.0126C28.6962 27.7036 30.1584 24.9372 29.9531 22.3716Z",
  fill: "url(#paint13_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9531 22.3716V12.8872C29.8531 11.9872 29.2031 10.7779 27.5156 10.7779C25.5469 10.8716 25.4688 12.8872 25.4688 12.8872L22.4688 7.5279C21.7188 6.38726 20.4888 6.30788 19.7188 6.77788C18.9488 7.24788 18.7813 8.19976 18.7813 8.19976L18.1563 7.38726C17.6863 6.61726 16.2798 6.52758 15.5625 6.96538C14.372 7.69204 14.199 9.19658 14.9688 10.0279C14.9183 9.97335 14.0569 9.86375 13.3438 10.3716C12.5486 10.938 12.3359 12.2467 12.7656 13.0435C13.1953 13.8403 13.2578 13.9653 13.2578 13.9653C13.2578 13.9653 12.5938 13.6528 11.5469 14.356C10.798 14.8589 10.53 16.3516 11 17.1216L13.5212 21.3726L16.9912 27.0426C19.0313 29.9341 23.3808 30.9325 26.5412 29.0126C28.6962 27.7036 30.1584 24.9372 29.9531 22.3716Z",
  fill: "url(#paint14_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5156 10.7778C25.5469 10.8716 25.4688 12.8872 25.4688 12.8872L27.3438 15.9688C27.3438 15.9688 26.3594 13.1719 27.5156 10.7778Z",
  fill: "url(#paint15_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.6875 22.75L29.125 13.7969C29.035 12.9869 28.7688 11.1875 27.25 11.1875L26.9375 16.3437L24.5312 12.5625L22.0938 8.25C21.6543 7.58168 21.3594 7.48439 21.0156 7.40627C20.6719 7.32814 19.6562 7.32817 19.875 7.70319C20.0938 8.07822 22.625 11.8594 23.5469 13.4375C23.8905 14.0258 22.4982 15.0313 21.9688 14.2813C21.4393 13.5313 17.7188 8 17.7188 8C17.2957 7.30698 15.8125 7.03824 15.8125 7.70311C15.8125 8.37817 19.3737 12.7674 20.1719 14.9375C20.49 15.8024 19.3074 16.3728 18.875 15.7032C18.4426 15.0335 16.625 12.0313 15.7188 10.8125C15.4057 10.3915 14.4945 9.91683 14.1875 10.2969C13.5909 11.0356 14.2851 12.1423 14.6719 12.8594C14.8714 13.2294 17.1406 16.6428 18.0312 18.1719C18.4638 18.9146 16.9219 19.6094 16.5156 19.0938C16.1094 18.5782 15.0273 16.2514 14 14.9375C13.494 14.2904 12.4672 14.3224 12.1563 14.5313C11.4823 14.984 12.0578 16.1685 12.4808 16.8615C14.4668 20.5089 20.6872 32.0802 26.375 28.625C28.3145 27.4468 29.8722 25.0591 29.6875 22.75Z",
  fill: "url(#paint16_radial_20020_3433)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5.69185 6.4391L3.83185 5.6591C3.54185 5.5391 3.46185 5.1691 3.68185 4.9391L4.65185 3.9091C4.86185 3.6791 5.24185 3.7391 5.38185 4.0191L6.27185 5.8291C6.44185 6.1991 6.07185 6.5991 5.69185 6.4391Z",
  fill: "#1A80EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.69185 6.4391L3.83185 5.6591C3.54185 5.5391 3.46185 5.1691 3.68185 4.9391L4.65185 3.9091C4.86185 3.6791 5.24185 3.7391 5.38185 4.0191L6.27185 5.8291C6.44185 6.1991 6.07185 6.5991 5.69185 6.4391Z",
  fill: "url(#paint17_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.69185 6.4391L3.83185 5.6591C3.54185 5.5391 3.46185 5.1691 3.68185 4.9391L4.65185 3.9091C4.86185 3.6791 5.24185 3.7391 5.38185 4.0191L6.27185 5.8291C6.44185 6.1991 6.07185 6.5991 5.69185 6.4391Z",
  fill: "url(#paint18_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.69185 6.4391L3.83185 5.6591C3.54185 5.5391 3.46185 5.1691 3.68185 4.9391L4.65185 3.9091C4.86185 3.6791 5.24185 3.7391 5.38185 4.0191L6.27185 5.8291C6.44185 6.1991 6.07185 6.5991 5.69185 6.4391Z",
  fill: "url(#paint19_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.05185 4.81707L6.83185 3.16552C6.64185 2.90746 6.76185 2.53585 7.06185 2.44295L8.42185 2.01974C8.72185 1.92684 9.02185 2.17457 9.00185 2.49456L8.86185 4.56935C8.82185 4.99256 8.30185 5.15771 8.05185 4.81707Z",
  fill: "#1A80EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.05185 4.81707L6.83185 3.16552C6.64185 2.90746 6.76185 2.53585 7.06185 2.44295L8.42185 2.01974C8.72185 1.92684 9.02185 2.17457 9.00185 2.49456L8.86185 4.56935C8.82185 4.99256 8.30185 5.15771 8.05185 4.81707Z",
  fill: "url(#paint20_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.05185 4.81707L6.83185 3.16552C6.64185 2.90746 6.76185 2.53585 7.06185 2.44295L8.42185 2.01974C8.72185 1.92684 9.02185 2.17457 9.00185 2.49456L8.86185 4.56935C8.82185 4.99256 8.30185 5.15771 8.05185 4.81707Z",
  fill: "url(#paint21_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.05185 4.81707L6.83185 3.16552C6.64185 2.90746 6.76185 2.53585 7.06185 2.44295L8.42185 2.01974C8.72185 1.92684 9.02185 2.17457 9.00185 2.49456L8.86185 4.56935C8.82185 4.99256 8.30185 5.15771 8.05185 4.81707Z",
  fill: "url(#paint22_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.59127 9.08919L2.51979 9.35898C2.19871 9.40048 1.93977 9.10994 2.01227 8.78826L2.35407 7.35629C2.42657 7.04499 2.79944 6.89973 3.06873 7.07613L4.79842 8.2383C5.15058 8.48734 5.01593 9.03731 4.59127 9.08919Z",
  fill: "#1A80EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.59127 9.08919L2.51979 9.35898C2.19871 9.40048 1.93977 9.10994 2.01227 8.78826L2.35407 7.35629C2.42657 7.04499 2.79944 6.89973 3.06873 7.07613L4.79842 8.2383C5.15058 8.48734 5.01593 9.03731 4.59127 9.08919Z",
  fill: "url(#paint23_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.59127 9.08919L2.51979 9.35898C2.19871 9.40048 1.93977 9.10994 2.01227 8.78826L2.35407 7.35629C2.42657 7.04499 2.79944 6.89973 3.06873 7.07613L4.79842 8.2383C5.15058 8.48734 5.01593 9.03731 4.59127 9.08919Z",
  fill: "url(#paint24_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.59127 9.08919L2.51979 9.35898C2.19871 9.40048 1.93977 9.10994 2.01227 8.78826L2.35407 7.35629C2.42657 7.04499 2.79944 6.89973 3.06873 7.07613L4.79842 8.2383C5.15058 8.48734 5.01593 9.03731 4.59127 9.08919Z",
  fill: "url(#paint25_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3743 13.9863C13.3289 13.9678 13.285 13.951 13.2426 13.9358C13.2063 13.8659 13.0916 13.648 12.7656 13.0435C12.7261 12.9701 12.6921 12.8916 12.6638 12.8091C12.997 12.8047 13.3973 12.9162 13.7508 13.0598C14.1568 13.2248 14.5914 13.4692 14.9259 13.7665C15.1284 13.9465 15.341 14.2389 15.5407 14.5441C15.7486 14.8618 15.9724 15.2405 16.1944 15.6277C16.3292 15.8628 16.4627 16.0997 16.5926 16.33C16.899 16.8737 17.1851 17.3813 17.4198 17.744C17.5698 17.9758 17.5035 18.2854 17.2716 18.4354C17.0398 18.5854 16.7302 18.5191 16.5802 18.2872C16.328 17.8974 16.0166 17.3451 15.7025 16.7878C15.5766 16.5643 15.4501 16.34 15.3269 16.1252C15.1072 15.742 14.8952 15.384 14.704 15.0917C14.5046 14.7871 14.3546 14.5966 14.2616 14.5139C14.0336 14.3113 13.7052 14.1207 13.3743 13.9863Z",
  fill: "url(#paint26_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.8888 9.98907C14.7337 9.95976 14.5983 9.95127 14.4915 9.95459C14.6757 9.94107 14.8097 9.96376 14.8888 9.98907Z",
  fill: "url(#paint27_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.1756 10.646C15.7399 10.2587 15.2965 10.076 14.9437 10.0001C14.6863 9.70946 14.5404 9.34115 14.5089 8.95412C15.1067 8.94784 16.0053 9.15664 16.84 9.89861C17.0457 10.0815 17.3066 10.4478 17.5649 10.8397C17.8372 11.2529 18.1484 11.7606 18.4591 12.2793C18.6909 12.6663 18.9211 13.0569 19.1363 13.4221C19.5059 14.0493 19.8313 14.6014 20.0448 14.9314C20.1948 15.1633 20.1285 15.4728 19.8966 15.6228C19.6648 15.7729 19.3552 15.7065 19.2052 15.4747C18.9811 15.1283 18.6354 14.5418 18.2557 13.8976C18.0431 13.537 17.8198 13.158 17.6012 12.7931C17.2924 12.2776 16.9901 11.7847 16.73 11.3901C16.4559 10.9743 16.2653 10.7258 16.1756 10.646Z",
  fill: "url(#paint28_radial_20020_3433)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7845 8.18341L18.7975 8.20442C19.132 8.7426 19.5853 9.47128 20.06 10.2332C21.0079 11.7545 22.046 13.4155 22.3927 13.9513C22.5427 14.1832 22.8523 14.2495 23.0841 14.0995C23.316 13.9495 23.3823 13.6399 23.2323 13.4081C22.8915 12.8814 21.8593 11.23 20.9087 9.70437C20.4342 8.94285 19.9812 8.21449 19.6468 7.6765L19.3061 7.12817C18.9265 7.56165 18.8047 8.08498 18.7845 8.18341Z",
  fill: "url(#paint29_linear_20020_3433)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5625 10.9062C14.9896 10.9375 15.347 11.0028 15.847 11.7778C16.347 12.5528 17.9511 15.1841 18.7845 16.4966",
  stroke: "#FFE240",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9062 14.75C13.3333 14.7812 13.6907 14.8466 14.1907 15.6216C14.6907 16.3966 15.6042 18.1875 16.4375 19.5",
  stroke: "#FFE240",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 12.5312C14.4271 12.5625 14.9095 12.7396 15.4095 13.5146C15.9095 14.2896 16.9792 16.4688 17.8125 17.7812",
  stroke: "url(#paint30_linear_20020_3433)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 8.8125C16.1771 8.84375 17.191 9.16238 17.691 9.93738C18.191 10.7124 19.6042 13.4375 20.4375 14.75",
  stroke: "url(#paint31_linear_20020_3433)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.778 7.78296C17.2051 7.81421 17.5625 7.87954 18.0625 8.65454C18.5625 9.42954 21.3229 13.5938 22.1562 14.9062",
  stroke: "#FFE240",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.5225 7.55029C20.9496 7.58154 21.307 7.64688 21.807 8.42188C22.307 9.19687 25.0986 14.3906 25.932 15.7031",
  stroke: "#FFE240",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_f_20020_3433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.3463 11.8419C28.7009 12.082 28.9781 12.3168 29.0251 13.2379C29.0721 14.159 28.9024 20.053 28.9703 21.6062",
  stroke: "#FFE240",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_20020_3433",
  x: 6.7505,
  y: 6.89697,
  width: 19.0621,
  height: 24.5117,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.25,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_20020_3433",
  x: 10.8468,
  y: 6.3208,
  width: 19.8556,
  height: 23.9406,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_20020_3433",
  x: 13.0625,
  y: 9.40625,
  width: 7.22203,
  height: 8.59045,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_20020_3433",
  x: 11.4062,
  y: 13.25,
  width: 6.53133,
  height: 7.75012,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_20020_3433",
  x: 12.5,
  y: 11.0312,
  width: 6.81267,
  height: 8.25012,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_f_20020_3433",
  x: 14.25,
  y: 7.3125,
  width: 7.68767,
  height: 8.93762,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_f_20020_3433",
  x: 15.278,
  y: 6.28296,
  width: 8.37828,
  height: 10.1234,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_20020_3433",
  x: 19.0225,
  y: 6.05029,
  width: 8.40953,
  height: 11.153,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_f_20020_3433",
  x: 26.8463,
  y: 10.3419,
  width: 3.6871,
  height: 12.7643,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_20020_3433"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20020_3433",
  x1: 21.3125,
  y1: 29.375,
  x2: 13.625,
  y2: 15.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6C4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF6D47",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.4687 12.8125) rotate(58.4429) scale(4.65751 1.86185)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFAF33"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA8221"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.34375 11.3125) rotate(92.0826) scale(1.71989 1.71091)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFAE28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFAF31",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.125 16.2187) rotate(57.3311) scale(4.86307 1.39303)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9E29"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9E28",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(7.8125 15.6875) rotate(63.4349) scale(2.02644 1.65669)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9D25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9F24",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.7813 8.78125) rotate(58.3392) scale(4.4057 1.90405)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC133"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC93C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.5938 7.96875) rotate(52.3738) scale(1.89391 1.44733)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC53A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC83C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.1875 11.125) rotate(90.6384) scale(37.1273 32.1071)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.370081,
  stopColor: "#FF6C5E",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.540093,
  stopColor: "#FF6B5E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.0938 7.15625) rotate(59.8163) scale(3.54285 3.89595)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFAC31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA92E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.28125 16.6875) rotate(-35.0958) scale(1.41318 4.33549)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DB5703"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.594695,
  stopColor: "#C94A04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D65A05",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.6562 13.6562) rotate(-42.6141) scale(2.12316 6.81377)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DB5703"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.594695,
  stopColor: "#C94A04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D65A05",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14 11.4687) rotate(-42.1844) scale(1.34955 4.43081)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DB5703"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.594695,
  stopColor: "#C94A04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D65A05",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.5625 20.125) rotate(73.3649) scale(10.6977 7.10071)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD945"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.633239,
  stopColor: "#FFD343"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD543",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29.9723 15.8125) rotate(98.4363) scale(14.7218 3.88781)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE143",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.6875 33.25) rotate(-124.618) scale(23.5432 18.5289)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA825D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.882533,
  stopColor: "#F67B7D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_20020_3433",
  x1: 25.625,
  y1: 13.3733,
  x2: 27.6719,
  y2: 13.2344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D48820"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.344595,
  stopColor: "#E39C2A",
  stopOpacity: 0.648599
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.735218,
  stopColor: "#FFC03C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.5625 20.4375) rotate(134.506) scale(10.2534 26.8268)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDB45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.484081,
  stopColor: "#FFD646"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.915211,
  stopColor: "#FFDA45",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.970164,
  stopColor: "#FFDA45",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_20020_3433",
  x1: 3.89062,
  y1: 4.54687,
  x2: 4.44317,
  y2: 5.06547,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2065A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2067AE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_20020_3433",
  x1: 4.60156,
  y1: 6.58594,
  x2: 4.91047,
  y2: 5.87212,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.605233,
  stopColor: "#1C60FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1963FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_20020_3433",
  x1: 5.76562,
  y1: 4.57813,
  x2: 5.36209,
  y2: 4.79146,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2093F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2294F3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_20020_3433",
  x1: 7.67187,
  y1: 1.89063,
  x2: 7.93372,
  y2: 2.75521,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2065A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2067AE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_20020_3433",
  x1: 7.375,
  y1: 4.58594,
  x2: 7.91934,
  y2: 4.18815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.605233,
  stopColor: "#1C60FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1963FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_20020_3433",
  x1: 8.9375,
  y1: 3.04687,
  x2: 8.66347,
  y2: 3.03267,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2093F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2294F3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_20020_3433",
  x1: 2,
  y1: 8.18147,
  x2: 2.67187,
  y2: 8.34375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2065A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2067AE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_20020_3433",
  x1: 3.5,
  y1: 9.73437,
  x2: 3.4375,
  y2: 8.9375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.605233,
  stopColor: "#1C60FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1963FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_20020_3433",
  x1: 3.91016,
  y1: 7.49609,
  x2: 3.62109,
  y2: 7.91797,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2093F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2294F3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint26_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.6562 15.6623) rotate(57.1255) scale(5.23917 0.981437)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B64200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB02E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint27_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.8124 12.3285) rotate(57.5206) scale(6.16885 1.1483)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B64200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB02E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint28_radial_20020_3433",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.8124 12.3285) rotate(57.5206) scale(6.16885 1.1483)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B64200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB02E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_20020_3433",
  x1: 20.1875,
  y1: 10.4375,
  x2: 21.0485,
  y2: 9.9375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E49224"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.589269,
  stopColor: "#FFB02E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear_20020_3433",
  x1: 14.4063,
  y1: 14.6875,
  x2: 16.3125,
  y2: 13.5937,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDB137"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.447171,
  stopColor: "#FFBA3C",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCAD33",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear_20020_3433",
  x1: 16.6878,
  y1: 11.1102,
  x2: 18.594,
  y2: 10.0165,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDB137"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.447171,
  stopColor: "#FFBA3C",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCAD33",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20020_3433"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

function SvgClappingHands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClappingHands);
export default __webpack_public_path__ + "static/media/clapping-hands.40d96928.svg";
export { ForwardRef as ReactComponent };